if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super()

        this.form = this.querySelector('form')
        this.variantIdInput.disabled = false
        this.cart = document.querySelector('cart-drawer')
        this.submitButton = this.querySelector('[type="submit"]')
        this.submitButtonText = this.submitButton.querySelector('span')

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog')

        this.hideErrors = this.dataset.hideErrors === 'true'

        if(document.body.classList.contains('template-cart')) {
          this.cart = document.querySelector('cart-items')
          this.form.addEventListener('submit', this.onSubmitHandlerCart.bind(this))
        } else {
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
        }

      }

      onSubmitHandler(evt) {
        evt.preventDefault()
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return

        this.handleErrorMessage()

        this.submitButton.setAttribute('aria-disabled', true)
        this.submitButton.classList.add('loading')
        this.querySelector('.loading__spinner').classList.remove('hidden')

        const config = fetchConfig('javascript')
        config.headers['X-Requested-With'] = 'XMLHttpRequest'
        delete config.headers['Content-Type']

        const formData = new FormData(this.form)
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          )
          formData.append('sections_url', window.location.pathname)
          this.cart.setActiveElement(document.activeElement)
        }
        config.body = formData

        console.log(formData)

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              })
              this.handleErrorMessage(response.description)

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message')
              if (!soldOutMessage) return
              this.submitButton.setAttribute('aria-disabled', true)
              this.submitButtonText.classList.add('hidden')
              soldOutMessage.classList.remove('hidden')
              this.error = true
              return
            } else if (!this.cart) {
              window.location = window.routes.cart_url
              return
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers')
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker)
              })
            this.error = false

            CartPerformance.measure("add:paint-updated-sections", () => {
              this.cart.renderContents(response)
            })
          })
          .catch((e) => {
            console.error(e)
          })
          .finally(() => {
            this.submitButton.classList.remove('loading')
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty')
            if (!this.error) this.submitButton.removeAttribute('aria-disabled')
            this.querySelector('.loading__spinner').classList.add('hidden')

            CartPerformance.measureFromEvent("add:user-action", evt)
          })
      }

      onSubmitHandlerCart(evt) {

        console.log('onSubmitHandlerCart')

        console.log(this.cart.getSectionsToRender())

        evt.preventDefault()
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return

        this.handleErrorMessage()

        this.submitButton.setAttribute('aria-disabled', true)
        this.submitButton.classList.add('loading')
        this.querySelector('.loading__spinner').classList.remove('hidden')

        const config = fetchConfig('javascript')
        config.headers['X-Requested-With'] = 'XMLHttpRequest'
        delete config.headers['Content-Type']

        const formData = new FormData(this.form)
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          )
          formData.append('sections_url', window.location.pathname)
        }
        config.body = formData

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              })
              this.handleErrorMessage(response.description)

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message')
              if (!soldOutMessage) return
              this.submitButton.setAttribute('aria-disabled', true)
              this.submitButtonText.classList.add('hidden')
              soldOutMessage.classList.remove('hidden')
              this.error = true
              return
            } else if (!this.cart) {
              window.location = window.routes.cart_url
              return
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers')
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker)
              })
            this.error = false

          })
          .catch((e) => {
            console.error(e)
          })
          .finally(() => {
            this.submitButton.classList.remove('loading')
            if (!this.error) this.submitButton.removeAttribute('aria-disabled')
            this.querySelector('.loading__spinner').classList.add('hidden')

            if (!this.error) {
              this.classList.add('item-added')
              setTimeout(() => {
                this.classList.remove('item-added')
              }, 1000)
            }

            CartPerformance.measureFromEvent("add:user-action", evt)
          })
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper')
        if (!this.errorMessageWrapper) return
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message')

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled')
          if (text) this.submitButtonText.textContent = text
        } else {
          this.submitButton.removeAttribute('disabled')
          this.submitButtonText.textContent = window.variantStrings.addToCart
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]')
      }
    }
  )
}
